module.exports = __webpack_public_path__ + "static/media/6.b2e6486b.jpg";